import CustomTable from '@/components/CustomTable/CustomTable.vue';
import AdminNavBar from '@/components/AdminNavBar/AdminNavBar.vue';
import { API_BASE_URL } from "@/config";
import { validateToken } from '@/utils/auth';
import { format_date } from '@/utils/date_formatter';

export default {
  name: 'ServiceApplications',
  components: {
    AdminNavBar,
    CustomTable
  },
  data: () => ({
    currentTab: 'Pending',
    requested_clients:[],
    columns: [
      { label: 'Client', key: 'name_email' },
      { label: 'Date Joined', key: 'date_joined' },
    ]
  }),
  computed: {
    filteredData() {
      return this.data[this.currentTab];
    },
    client_id() {
      return this.$store.getters.get_client_id;
    }
  },
  methods: {
    formatDate(date) {
      return format_date(date);
    },
    switchTab(tab) {
      this.currentTab = tab;
    },
    getClients(page = 1, search = '') {
      const TOKEN = localStorage.getItem('token');
      return new Promise((resolve, reject) => {
        let url = `${API_BASE_URL}/verify_api/verify_admin_api/get_instant_verify_applications/?page=${page}`;
        if (search) {
          url += `&search=${encodeURIComponent(search)}`;
        }
        $.ajax({
          url: url,
          method: 'GET',
          dataType: 'json',
          headers: {
            Authorization: `Token ${TOKEN}`
          },
          success: function(data) {
            resolve({
              count: data.count,
              results: data.results,
            });
          },
          error: function(xhr, status, error) {
            reject(error);
          }
        });
      });
    },
    view_client_logs(client_id){
      this.$router.push({ name: 'view_logs'});
      this.$store.commit('set_client_id', client_id);
    },
    view_client_services(client_id){
      this.$router.push({ name: 'view_requested_services'});
      this.$store.commit('set_client_id', client_id);
    },
  },
  mounted() {
    if (!validateToken(this.$router)) {
      return;
  }
    this.getClients();
  }
};
